import React from 'react';
import './index.scss';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField'
import ListItem from '@material-ui/core/ListItem';

import { inject, observer } from 'mobx-react';
import { MenuItem } from '@material-ui/core';

@inject('translate')
@inject('internal')
@observer
export default class AddRepresentant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            message: "",
            openSnackbar: false,
            currency: null,
            primary: false
        }
    }

    componentDidMount() {
        if(this.props.representants && this.props.representants.length > 0) {
            this.setState({currency: this.props.representants[0].id})
        }
        else {
            this.setState({currency: 0})
        }
    }

    addRepresentat =  () => {
        this.props.createNewRepresentant(this.state.currency, this.state.primary);
    }

    
    handleChange = name => event => {
        this.setState({
          currency: event.target.value,
        } , () => {
        });
    };

    handleChangePrimary = (event) => {
        this.setState({primary: event.target.checked}, () => {
        })
        
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent className={'add-representant'}>
                
                    <TextField
                        className={'custom-select'}
                        id="standard-select-currency-native"
                        select
                        label={this.props.translate.i18n.MODULES.CLIENTS.REPRESENTATIVES}
                        value={this.state.currency}
                        onChange={this.handleChange('currency')}
                        // SelectProps={{
                        //     native: true,
                        
                        // }}
                        //helperText="Please select your currency"
                        margin="normal"
                        >
                        {this.props.representants && this.props.representants.length > 0 && this.props.representants.map((option, index) => {return (
                            option.available ?
                                <MenuItem key={option.id} value={option.id}>
                                    {option.username}
                                </MenuItem>
                                :
                                null
                            )
                        })}
                    </TextField>
                    <ListItem dense onChange={this.handleChangePrimary} className={'list-item'}>
                        <input id="primary" type="checkbox" value={"primary"} />
                        <label htmlFor="primary">{this.props.translate.i18n.MODULES.CLIENTS.IS_OZ_PRIMARY}</label>
                    </ListItem>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.addRepresentat} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                    {/* <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.addRepresentat}
                            style={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        /> */}
                </DialogActions>
                
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/representants/add/index.js